import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import {format as formatDate} from "date-fns";
import {FaCheckCircle, FaTimesCircle, FaClock} from "react-icons/fa";

import ApiService from "../../util/ApiService";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {Avatar} from "antd";
import AuthService from "../../util/AuthService";
import MapIframe from "../../util/MapIframe";
import Swal from "sweetalert2";

const DutyDetailModal = ({
                             show,
                             handleClose,
                             eventDetails,
                             onEdit,
                             onRepost,
                             onConvertToDuty,
                             buttonRepost = true,
                             buttonEdit = true
                         }) => {
    const [duty, setDuty] = useState({hospital: {}});
    const [loading, setLoading] = useState(true);
    const userData = AuthService.getUserData();

    useEffect(() => {
        if (show) {
            fetchDutyOneRecord(eventDetails.url_page);
        }
    }, [show]);

    const fetchDutyOneRecord = async (url) => {
        try {
            setLoading(true);
            const response = await ApiService.send('post', `${process.env.REACT_APP_URL_API}duty/onerecord/${url}`);
            const {data} = ApiService.handleApiResponse(response);
            setDuty(data);
        } catch (error) {
            ApiService.handleApiError(error);
            handleClose();
        } finally {
            setLoading(false);
        }
    };

    const formatDateTime = (dateTime) => {
        if (!dateTime) return "Data inválida";
        try {
            const isoDate = dateTime.includes("T") ? dateTime : dateTime.replace(" ", "T");
            return formatDate(new Date(isoDate), "dd/MM/yyyy HH:mm");
        } catch (error) {
            ApiService.handleApiError(error);
            return "Erro ao formatar data";
        }
    };

    const getStatusIcon = (status) => {
        switch (status) {
            case "pending": return <FaClock color="#ffc107"/>;
            case "accepted": return <FaCheckCircle color="#28a745"/>;
            case "refused": return <FaTimesCircle color="#dc3545"/>;
            default: return null;
        }
    };

    const calculateDuration = (startTime, endTime) => {
        if (!startTime || !endTime) return "Duração inválida";
        const start = new Date(startTime.includes("T") ? startTime : startTime.replace(" ", "T"));
        const end = new Date(endTime.includes("T") ? endTime : endTime.replace(" ", "T"));
        const duration = end - start;
        const hours = Math.floor(duration / 3600000);
        const minutes = Math.floor((duration % 3600000) / 60000);
        return `${hours} hora(s) e ${minutes} minuto(s)`;
    };


    const handleDelete = async (dutyId) => {
        try {
            const result = await Swal.fire({
                title: 'Tem certeza?',
                text: "Você não poderá reverter isso!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, deletar!',
                cancelButtonText: 'Cancelar'
            });

            if (result.isConfirmed) {
                await ApiService.send("delete", process.env.REACT_APP_URL_API + "duty/delete", {id: dutyId});
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'Plantão deletado com sucesso.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => {
                    handleClose(true);
                });
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    const formatValue = (value) => {
        const num = typeof value === "number" ? value : parseFloat(value);
        return isNaN(num) ? value : num.toLocaleString("pt-BR", {minimumFractionDigits: 2, maximumFractionDigits: 2});
    };

    return (
        <Modal show={show} onHide={handleClose} centered size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Detalhes do Plantão</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            {loading ? (
                                <Skeleton count={5} height={20}/>
                            ) : duty?.id ? (
                                <div className="event-details">
                                    <div className="row mb-3">
                                        <div className="col-3">
                                            <img
                                                src={duty?.hospital?.images?.[0]?.file || `${process.env.REACT_APP_URL_STORAGE}src/hospital_icone.png`}
                                                alt={duty?.hospital?.name}
                                                width={100}
                                                className="img-fluid rounded"
                                            />
                                        </div>
                                        <div className="col-9">
                                            <p className="hospital-name">
                                                <a target="_blank" rel="noopener noreferrer" href={`/admin/location-detail/${duty.hospital.url_page}`}>
                                                    {duty?.hospital?.name || "Nome não disponível"}
                                                </a>
                                            </p>
                                            <p className="hospital-phone">
                                                Telefone: {duty?.hospital?.phone_number || "Telefone não disponível"}
                                            </p>
                                        </div>
                                    </div>

                                    <hr/>

                                    <div className="datetime-info">
                                        <p>
                                            <span className="badge bg-dark d-inline-flex align-items-center">
                                                <i className="fa fa-hospital text-info me-2"></i> {duty?.department?.name}
                                            </span>
                                        </p>
                                        {duty?.accept_user_origin?.id !== duty?.accept_user?.id && (

                                            <p className="mb-3 " title="Original da Escala">
                                                <i className="fa fa-user me-1 text-info"></i>
                                                {duty?.accept_user_origin?.name}
                                            </p>

                                        )}
                                        <p><i className="fa  text-info fa-calendar-check-o"></i> Início: {formatDateTime(duty?.date_time)}</p>
                                        <p><i className="fa  text-info fa-calendar-check-o"></i> Término: {formatDateTime(duty?.date_time_end)}</p>
                                        <p><i className="fa  text-info fa-clock-o"></i> {calculateDuration(duty?.date_time, duty?.date_time_end)}</p>
                                    </div>

                                    <p className="value-info">
                                        <i className="fa  text-info fa-money"></i>: <strong>R$ {formatValue(duty?.value)}</strong>
                                    </p>

                                    <hr/>

                                    <div className="row">
                                        <div className="col-6">
                                            <div className="d-flex align-items-center mb-2">
                                                <Avatar
                                                    src={duty?.user?.profile_image || `${process.env.REACT_APP_URL_STORAGE}src/perfil_icone.png`}
                                                    size={32}
                                                    className="me-2  rounded-circle header-profile-user header-profile-user-perfil  object-fit-cover"
                                                />
                                                <h6 className="mb-0">{duty?.user?.name || 'Nome não disponível'}</h6>
                                            </div>
                                            <p>{duty?.user?.city || ''}</p>
                                            {duty?.user?.ddd && duty?.user?.phone && (
                                                <p>
                                                    <a className="btn btn-sm btn-success" href={`https://wa.me/55${duty.user.ddd}${duty.user.phone}`} target="_blank" rel="noopener noreferrer">
                                                        <i className="fa fa-whatsapp"></i>
                                                    </a>{' '}({duty.user.ddd}) {duty.user.phone}
                                                </p>
                                            )}
                                        </div>

                                        <div className="col-6">
                                            {duty?.accept_user ? (
                                                <>
                                                    <div className="d-flex align-items-center mb-2">
                                                        <Avatar
                                                            src={duty.accept_user.profile_image || `${process.env.REACT_APP_URL_STORAGE}src/perfil_icone.png`}
                                                            size={32}
                                                            className="me-2  rounded-circle header-profile-user header-profile-user-perfil  object-fit-cover"
                                                        />
                                                        <h6 className="mb-0">{duty?.accept_user?.name || 'Nome não disponível'}</h6>
                                                    </div>
                                                    <p>{duty?.accept_user?.city || ''}</p>
                                                    {duty?.accept_user?.ddd && duty?.accept_user?.phone && (
                                                        <p>
                                                            <a className="btn btn-sm btn-success" href={`https://wa.me/55${duty.accept_user.ddd}${duty.accept_user.phone}`} target="_blank" rel="noopener noreferrer">
                                                                <i className="fa fa-whatsapp"></i>
                                                            </a>{' '}({duty.accept_user.ddd}) {duty.accept_user.phone}
                                                        </p>
                                                    )}
                                                </>
                                            ) : (
                                                <div className="alert alert-primary" role="alert">
                                                    Nenhum Usuário Aceito
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="alert alert-warning text-center">
                                    <i className="fa fa-exclamation-circle"></i> Plantão Indisponível
                                </div>
                            )}
                        </div>
                        <div className="col-md-6">
                            {eventDetails && !loading && duty?.hospital?.latitude && duty?.hospital?.longitude && (
                                <MapIframe
                                    name={duty?.hospital?.name}
                                    latitude={duty?.hospital?.latitude}
                                    longitude={duty?.hospital?.longitude}
                                    width="100%"
                                    height="100%"
                                    zoom={18}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>

              <div className="mt-2">

                  {buttonRepost && duty?.accept_user?.id === userData?.id && (
                      <button type="button" className="btn btn-info me-2" onClick={() => onRepost(duty)}>
                          <i className="fa fa-exchange"></i> Repostar
                      </button>
                  )}
                  {buttonEdit && (
                      duty?.logged_in_user === userData?.id ||
                      duty?.user_id ===  userData?.id
                  ) && (
                      <>
                          <button
                              type="button"
                              className="btn btn-primary me-2"
                              onClick={() => onEdit(duty)}
                              disabled={!(duty?.id > 0)}
                          >
                              <i className="fa fa-edit"></i> Editar
                          </button>

                          <button
                              type="button"
                              className="btn btn-danger me-2"
                              onClick={() => handleDelete(duty.id)}
                              disabled={!(duty?.id > 0)}
                          >
                              <i className="fa fa-close"></i> Excluir
                          </button>
                      </>

                  )}
                  <button type="button" className="btn btn-secondary" onClick={handleClose}>
                      <i className="fa fa-close"></i> Fechar
                  </button>

              </div>
            </Modal.Footer>
        </Modal>
    );
};

export default DutyDetailModal;
